import React, { FC } from 'react';
import LoopIcon from '@mui/icons-material/Loop';
import { StyledLoadingButton } from './styled';
import { animations } from 'themes';
import { SimpleLoadingButtonProps } from './types';

const SimpleLoadingButton: FC<SimpleLoadingButtonProps> = ({
  isLoading,
  onClick,
  dimensions = {},
  children,
  ...rest
}) => {
  const { width, height } = dimensions;

  return (
    <StyledLoadingButton
      onClick={onClick}
      loading={isLoading}
      disabled={isLoading}
      loadingIndicator={<LoopIcon sx={{ animation: `${animations.spin} 2s linear infinite` }} fontSize={'small'} />}
      variant='outlined'
      width={width}
      height={height}
      {...rest}
    >
      {children}
    </StyledLoadingButton>
  );
};

export default SimpleLoadingButton;
